import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueResource from 'vue-resource'
import { routes } from './routes'
import jQuery from 'jquery'
import { store } from './store/store'

Vue.use(VueRouter);
Vue.use(VueResource);

//Ajout de jquery
window.Jquery = window.$ = jQuery;

/***************************************************************
 *
 *   ajout serviceWorker.js pour PWA
 *
 **************************************************************/
if('serviceWorker' in navigator){

    /**
     * Service worker
     */
    try {
        navigator.serviceWorker.register('/sw.js');
        console.log("[main.js] Service Worker Registered");
    } catch (error) {
        console.log("[main.js] Service Worker Registration Failed");
    }

    navigator.serviceWorker.addEventListener('message', e => {
        if (e.data === 'offline') { // envoyer par la fonction 'isOffline' de sw.js
            console.log('service worker says offline')
        }
    });

    navigator.serviceWorker.ready
        .then( registration => {
            console.log('[main.js] serviceWorker ready')
            registration.active.postMessage("Hi service worker");
        })
        .then(() => {
            // initialisation de l'app
            // ajout d'un setTimeout pour laisser un delai supplémentaire pour que l'evenement fetch au niveau du wervice worker soit initialiser meme si on attend pourtant l'evenemet navigator.serviceWorker.ready
            setTimeout(() => {
                MyCoachApp.initialize();
            }, 500);
        });

    /**
     * ajout d'un ecouteur sur l'evenement 'beforeinstallprompt' si l'app rempli les prérequis pour être installable
     * https://web.dev/install-criteria/
     */
    // const pwaPromotion = new PwaPromotion();
    // pwaPromotion.init();
}


const router = new VueRouter({
  // mode: 'history', //ne pas mettre le mode history sinon la premiere route sera sous android "android_asset/www/index.html" au lieu de "/"
  routes: routes
});

const urlJson = 'https://extranet.artetfenetres.com/external/public/api/v1/mycoach/json';


//centralisation des evenements entre les differentes vues
export const eventBus = new Vue();


var MyCoachApp = {

    vuejs: '',

    // Application Constructor
    initialize() {
        console.warn('initiliaze app')
        this.bindEvents()
    },

    // Bind Event Listeners
    bindEvents() {
        this.receivedEvent();
    },

    // Update DOM on a Received Event
    receivedEvent() {
        // Load Vue instance
        this.vuejs = new Vue({
            el: '#app',
            router: router,
            store: store,
            render: h => h(App),
            created() {
                //on ajoute un numero en random pour eviter la mise en cache du fichier
                let noCacheNumber = Math.round(Math.random()*10000000) + 1;
                //on charge le json en ligne

                this.$http.get(urlJson+'?'+noCacheNumber)
                    // this.$http.get('http://localhost:8080/dist/assets/init.json')
                    .then(response => {
                        return response.json()
                    })
                    .then( data => {
                        //on stocke le data dans le store
                        if(data.ad.length) {
                            this.$store.state.ad = data.ad;
                        }
                        else {
                            this.$store.state.ad = null;
                        }
                        this.$store.state.contacts = data.contacts;
                        this.$store.state.calendar.actions = data.actions;
                        this.$store.state.calendar.events = data.events;

                        // //ainsi que le localforage pour une utilisation en déconnecté
                        // localForage.setItem('actions', data.actions);
                        // localForage.setItem('events', data.events);
                        // localForage.setItem('ads', data.ad);

                        this.$store.commit('isReady');
                    });
            },
            methods: {
                updateJson() {
                    //on ajoute un numero en random pour eviter la mise en cache du fichier
                    let noCacheNumber = Math.round(Math.random()*10000000) + 1;
                    //on charge le json en ligne
                    this.$http.get(urlJson+'?'+noCacheNumber)
                    // this.$http.get('http://localhost:8080/dist/assets/init.json')
                        .then(response => {
                            return response.json()
                        })
                        .then( data => {
                            //on stocke le data dans le store
                            if(data.ad)
                                this.$store.state.ad = data.ad;
                            else
                                this.$store.state.ad = null;
                            this.$store.state.contacts = data.contacts;
                            this.$store.state.calendar.actions = data.actions;
                            this.$store.state.calendar.events = data.events;

                        });
                }
            }
        });
    }
};




// WEBPACK FOOTER //
// ./src/main.js